import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Copy, Check, RefreshCw } from 'lucide-react';
export function PasswordGenerator() {
  const [password, setPassword] = useState('');
  const [length, setLength] = useState('16');
  const [includeUppercase, setIncludeUppercase] = useState(true);
  const [includeLowercase, setIncludeLowercase] = useState(true);
  const [includeNumbers, setIncludeNumbers] = useState(true);
  const [includeSymbols, setIncludeSymbols] = useState(true);
  const [copied, setCopied] = useState(false);
  const generatePassword = () => {
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';
    let chars = '';
    if (includeUppercase) chars += uppercase;
    if (includeLowercase) chars += lowercase;
    if (includeNumbers) chars += numbers;
    if (includeSymbols) chars += symbols;
    if (chars === '') {
      chars = lowercase; // Default to lowercase if nothing selected
    }
    let result = '';
    const passwordLength = parseInt(length);
    for (let i = 0; i < passwordLength; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setPassword(result);
    setCopied(false);
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="container mx-auto px-4 py-8 max-w-2xl" data-id="element-167">
      <div className="mb-8" data-id="element-168">
        <h1 className="text-4xl font-bold mb-2" data-id="element-169">Password Generator</h1>
        <p className="text-muted-foreground" data-id="element-170">
          Generate secure random passwords
        </p>
      </div>

      <Card data-id="element-171">
        <CardHeader data-id="element-172">
          <CardTitle data-id="element-173">Password Settings</CardTitle>
          <CardDescription data-id="element-174">
            Customize your password requirements
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6" data-id="element-175">
          <Input type="number" label="Password Length" value={length} onChange={e => setLength(e.target.value)} min="4" max="128" data-id="element-176" />

          <div className="space-y-3" data-id="element-177">
            <label className="block text-sm font-medium" data-id="element-178">Character Types</label>
            <div className="space-y-2" data-id="element-179">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-180">
                <input type="checkbox" checked={includeUppercase} onChange={e => setIncludeUppercase(e.target.checked)} className="w-4 h-4 rounded border-input" data-id="element-181" />
                <span className="text-sm" data-id="element-182">Uppercase (A-Z)</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-183">
                <input type="checkbox" checked={includeLowercase} onChange={e => setIncludeLowercase(e.target.checked)} className="w-4 h-4 rounded border-input" data-id="element-184" />
                <span className="text-sm" data-id="element-185">Lowercase (a-z)</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-186">
                <input type="checkbox" checked={includeNumbers} onChange={e => setIncludeNumbers(e.target.checked)} className="w-4 h-4 rounded border-input" data-id="element-187" />
                <span className="text-sm" data-id="element-188">Numbers (0-9)</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-189">
                <input type="checkbox" checked={includeSymbols} onChange={e => setIncludeSymbols(e.target.checked)} className="w-4 h-4 rounded border-input" data-id="element-190" />
                <span className="text-sm" data-id="element-191">Symbols (!@#$%...)</span>
              </label>
            </div>
          </div>

          <Button onClick={generatePassword} className="w-full" data-id="element-192">
            <RefreshCw className="w-4 h-4 mr-2" data-id="element-193" />
            Generate Password
          </Button>

          {password && <div className="space-y-3" data-id="element-194">
              <div className="p-4 bg-muted rounded-lg font-mono text-lg break-all" data-id="element-195">
                {password}
              </div>
              <Button onClick={copyToClipboard} variant="outline" className="w-full" data-id="element-196">
                {copied ? <Check className="w-4 h-4 mr-2" data-id="element-197" /> : <Copy className="w-4 h-4 mr-2" data-id="element-198" />}
                {copied ? 'Copied!' : 'Copy Password'}
              </Button>
            </div>}
        </CardContent>
      </Card>
    </div>;
}